import clsx from "clsx";

interface LabelProps extends React.ComponentProps<"label"> {
  children: React.ReactNode;
}

export function Label({ children, className, ...rest }: LabelProps) {
  return (
    <label
      htmlFor="country"
      className={clsx("block text-sm font-medium text-gray-700", className)}
      {...rest}
    >
      {children}
    </label>
  );
}
